import { Controller } from 'react-hook-form'
import { Icon } from '@iconify/react'
import PageHeader from '../../../layouts/PageHeader'
import { useLocation } from 'react-router-dom'
export default function SearchHeader({
  title,
  placeholder = '',
  control,
  name = 'keyword',
}) {
  const data = localStorage.getItem('isBorrowBookInfo')
  const isListUserPerBookBorrowPage = data ? true : false
  const location = useLocation()
  const arrLocation = location.pathname.split('/')
  const isPageBookBorrow = arrLocation[1]
  return (
    <div
      className={`flex flex-col gap-3 lg:flex-row lg:items-center ${isListUserPerBookBorrowPage ? `h-8` : null}`}
    >
      <div
        className={
          isListUserPerBookBorrowPage ? `min-w-[440px]` : `min-w-[360px]`
        }
      >
        <PageHeader>{title}</PageHeader>
      </div>
     {isPageBookBorrow ==='book-borrow'|| isPageBookBorrow==='info-guest-account'? 
    null:
    <Controller
    name={name}
    control={control}
    render={({ field }) => (
      <div
        className={`relative flex w-full items-center overflow-hidden rounded-lg shadow-xl ${isListUserPerBookBorrowPage ? `mb-8` : null}`}
      >
        <input
          type="search"
          className="block w-full rounded-l-lg border border-gray-300 bg-[#FFFFFF] p-3 text-secondarygray focus:border-gray-accent focus:outline-none focus:ring-0 lg-c:p-4"
          placeholder={placeholder}
          value={field.value || ''}
          onChange={field.onChange}
        />
        <button
          type="submit"
          className="absolute right-0 top-0 flex h-full items-center justify-between gap-3 rounded-r-lg border border-gray-accent bg-gray-accent p-3 font-semibold text-white hover:bg-gray-secondary focus:bg-gray-accent focus:outline-none lg-c:p-4"
        >
          <Icon
            icon="ph:magnifying-glass-bold"
            width="24"
            height="24"
            style={{ color: 'white' }}
          />
          <span>Tìm kiếm</span>
        </button>
      </div>
    )}
  /> 
    }
    </div>
  )
}
